type Ease = { [key: string]: Ease.Fn | ((...args: any[]) => Ease.Fn) | Ease };
namespace Ease {
  export type Fn = (t: number) => number;

  export const sine = {
    out: (t: number) => Math.sin((t * Math.PI) / 2),
    in: (t: number) => 1 - Math.cos((t * Math.PI) / 2),
  } satisfies Ease;
}

export default Ease;
